import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { CommerceOrderItem } from "@teqtank/commerce-sdk";
@customElement("teqtank-order-items")
export class TeqtankOrderItems extends LitElement {
    @property({ attribute: false })
    public accessor items: readonly CommerceOrderItem[] = [];
    public static override styles = css`
        :host {
            container-type: inline-size;
            display: block;
        }
        .item {
            display: grid;
            grid-template-columns: 1fr auto;
            gap: 1rem;
            padding: 1rem 0;
            border-bottom: 1px solid var(--teqtank-color-border, #ded8cf);
        }
        .item:last-child {
            border-bottom: 0;
        }
        strong,
        span {
            display: block;
        }
        .item-meta {
            font-size: 0.78rem;
            color: var(--teqtank-color-text-muted, #69736d);
            margin-top: 0.25rem;
        }
        .price {
            text-align: right;
        }
    `;
    protected override render() {
        return html`${this.items.map(
            (item) =>
                html`<div class="item">
                    <div>
                        <strong>${item.name}</strong
                        ><span class="item-meta"
                            >${item.displaySku ? `${item.displaySku} · ` : ""}Qty
                            ${item.quantity}</span
                        >
                    </div>
                    <div class="price">${item.lineTotal.formatted}</div>
                </div>`,
        )}`;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        "teqtank-order-items": TeqtankOrderItems;
    }
}
